"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguagePicker = void 0;
const Language_1 = __importStar(require("@opsbase/lib-i18n/Language"));
const LanguageIcon_1 = __importDefault(require("@opsbase/web-icons/LanguageIcon"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const MenuItem_1 = __importDefault(require("@opsbase/web-ui/MenuItem"));
const Select_1 = __importDefault(require("@opsbase/web-ui/Select"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importDefault(require("react"));
const makePicker_1 = __importDefault(require("../helpers/makePicker"));
exports.LanguagePicker = (0, makePicker_1.default)((props) => {
    const { value, allowed = Object.values(Language_1.default), flagOnly = false } = props;
    const sValue = Array.isArray(value) ? value.filter(l => !!l) : value;
    return (react_1.default.createElement(Select_1.default, Object.assign({ value: sValue }, props, { renderValue: v => (react_1.default.createElement(Horizontal_1.default, { gutter: true, style: { overflow: 'auto', maxWidth: 280 } }, (Array.isArray(v) ? v : [v]).map(vv => (react_1.default.createElement(Horizontal_1.default, { gutter: true, centered: true, key: vv, justify: 'flex-start' },
            react_1.default.createElement(LanguageIcon_1.default, { language: vv }),
            !flagOnly && react_1.default.createElement(Text_1.default, null, (0, Language_1.languageLabel)(vv))))))) }), allowed.map(language => (react_1.default.createElement(MenuItem_1.default, { key: language, value: language },
        react_1.default.createElement(Horizontal_1.default, { gutter: true, centered: true, justify: 'flex-start' },
            react_1.default.createElement(LanguageIcon_1.default, { language: language }),
            react_1.default.createElement(Text_1.default, null, (0, Language_1.languageLabel)(language))))))));
});
exports.default = exports.LanguagePicker;
